import React, { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import { Stack, TextField } from "@mui/material"

const CODE_HELPER = "Maximum 15 caractères, lettres majuscules (A–Z), chiffres (0–9), underscore ( _ )"

const suggestCode = (name) =>
  name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9_]/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 15)

const GeneralInfoSection = () => {
  const { values, errors, touched, handleChange, setFieldValue } = useFormikContext()

  // Track whether the user has manually edited the code field.
  // If the form opens with an existing code, auto-suggest is disabled from the start.
  const [codeTouched, setCodeTouched] = useState(() => values.code !== "")

  useEffect(() => {
    if (codeTouched) return
    setFieldValue("code", suggestCode(values.name))
  }, [values.name, codeTouched])

  const handleCodeChange = (e) => {
    setCodeTouched(true)
    setFieldValue("code", e.target.value.toUpperCase().slice(0, 15))
  }

  return (
    <Stack spacing={3}>
      <TextField
        label="Nom de l'entreprise"
        name="name"
        value={values.name}
        onChange={handleChange}
        error={touched.name && !!errors.name}
        helperText={touched.name && errors.name}
        required
        variant="standard"
        fullWidth
        autoFocus
        inputProps={{ maxLength: 100 }}
      />
      <TextField
        label="Code"
        name="code"
        value={values.code}
        onChange={handleCodeChange}
        error={touched.code && !!errors.code}
        helperText={(touched.code && errors.code) || CODE_HELPER}
        required
        variant="standard"
        fullWidth
        inputProps={{ maxLength: 15 }}
      />
    </Stack>
  )
}

export default GeneralInfoSection
